import { render, staticRenderFns } from "./BoxProcedimento.vue?vue&type=template&id=50d514ca&"
import script from "./BoxProcedimento.vue?vue&type=script&lang=js&"
export * from "./BoxProcedimento.vue?vue&type=script&lang=js&"
import style0 from "./BoxProcedimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports